import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Header } from "semantic-ui-react";
import { switchMode } from "../../actions/modeActions";
import { userRoles } from "../../constants";

const ModeSwitch = () => {
  const dispatch = useDispatch();
  const hasRights = useSelector((state) =>
    state.auth.user.roles.some((role) =>
      [userRoles.REVIEWER, userRoles.ADMIN].includes(role)
    )
  );
  const reviewer = useSelector((state) => state.mode.reviewer);
  const isRecording = useSelector((state) => state.microphone.isRecording);
  return (
    <>
      {hasRights && (
        <Header color="grey" size="tiny" floated="right">
          reviewer mode:{" "}
          <Radio
            toggle
            floated="right"
            checked={reviewer}
            onChange={() => dispatch(switchMode())}
            disabled={isRecording}
          />
        </Header>
      )}
    </>
  );
};

export default ModeSwitch;
